import axios from 'axios'
// console.log('process', process.env)
window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.baseURL = process.env.VUE_APP_URL